<gen-dynamic-form class="patient-details-wrapper" [formConfig]="_formConfig" [formData]="formData"
                  [listenToDataChange]="listenToDataChange"
                  [submitted]="widgetFormInstanceSubmitted"
                  [popupMode]="true"
                  (formChange)="formUpdate($event.form)">
</gen-dynamic-form>

<gen-button [type]="'primary'"
            [text]="'Link'"
            (click)="linkReportTemplate()">
</gen-button>
